<template>
  <a-popconfirm
    :title="confirmTitle"
    :ok-text="confirmOkText"
    :cancel-text="confirmCancelText"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      <a-button type="link">{{ $t('constructionPermit.删除') }}</a-button>
    </slot>
  </a-popconfirm>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    }
  },
  data() {
    return {
      confirmTitle: this.title || this.$t('constructionPermit.是否删除该项'),
      confirmOkText: this.okText || this.$t('constructionPermit.确定'),
      confirmCancelText: this.cancelText || this.$t('constructionPermit.取消')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/component/base/confirmButton.vue